import { useLanguageData } from '@/common/hooks/useLanguageData';
import { MessageBubble } from '../../message/message.styles';
import {
	PlaceholderWrapper,
	TypingDot,
	TypingDots,
	TypingLabel,
} from '../loadingPlaceholders.styles';

const TextTypingPlaceholder = ({ labelKey, alignRight = false }) => {
	const t = useLanguageData('chat');

	return (
		<PlaceholderWrapper $alignRight={alignRight}>
			<MessageBubble isSender={alignRight} role="status" aria-live="polite">
				<TypingDots aria-hidden="true">
					<TypingDot $delay={0} />
					<TypingDot $delay={0.15} />
					<TypingDot $delay={0.3} />
				</TypingDots>
				<TypingLabel>{t[labelKey]}</TypingLabel>
			</MessageBubble>
		</PlaceholderWrapper>
	);
};

export default TextTypingPlaceholder;
